import { components } from "@/api-schema";
import { formatApiDateOnlyToLocale } from "@/common/helpers/format-date";
import { SubComponentInfoCard } from "@/components/data-table/predefined/_components/sub-component-info-card";
import { SystemInfoSubComponent } from "@/components/data-table/predefined/_components/system-info-sub-component";
import { DataTableRow } from "@/components/data-table/types";
import { BuildingIcon, CalendarIcon, DoorOpenIcon, MapPinIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

type Vehicle = components["schemas"]["Vehicle"] & {
  registrationDate?: string | null;
};

export interface VehicleSubComponentProps {
  row: DataTableRow<Vehicle>;
}

export function VehicleSubComponent({ row }: VehicleSubComponentProps) {
  const { t } = useTranslation(["masterdata", "common"]);
  const vehicle = row.original;
  const owningBranch = vehicle.owningBranch;
  const currentBranch = vehicle.currentBranch;

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      <SubComponentInfoCard
        icon={BuildingIcon}
        label={t("common:OwningBranch")}
        value={owningBranch?.name}
        relation={owningBranch ? { subject: "Branch", uuid: owningBranch.uuid } : undefined}
      />
      <SubComponentInfoCard
        icon={MapPinIcon}
        label={t("masterdata:CurrentBranch")}
        value={currentBranch?.name}
        relation={currentBranch ? { subject: "Branch", uuid: currentBranch.uuid } : undefined}
      />
      <SubComponentInfoCard
        icon={CalendarIcon}
        label={t("common:RegistrationDate")}
        value={formatApiDateOnlyToLocale(vehicle.registrationDate)}
      />
      <SubComponentInfoCard icon={DoorOpenIcon} label={t("common:NumberDoors")} value={vehicle.numberDoors} />
      <SystemInfoSubComponent uuid={vehicle.uuid} createdAt={vehicle.createdAt} updatedAt={vehicle.updatedAt} />
    </div>
  );
}
